import { useEffect, useState } from 'react';
import {
  MOBILE,
  SMALL_TABLET,
  TABLET,
  SMALL_SCREEN,
} from '../../../consts/breakpoints';
import {
  KLYDO_HEIGHT_WITHOUT_FRAME,
  KLYDO_WIDTH_WITHOUT_FRAME,
} from '../../../consts/clockDimensions';

export const useResponsiveClockScale = () => {
  const [scale, setScale] = useState(1);

  const updateScale = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const widthUtilization = width <= MOBILE ? 1 : 0.9;
    const heightUtilization = width <= MOBILE ? 0.95 : 0.9;

    const effectiveWidth =
      width * widthUtilization - (width <= MOBILE ? 32 : 0);

    const widthScale = effectiveWidth / KLYDO_WIDTH_WITHOUT_FRAME;

    const heightScale =
      (height * heightUtilization) / KLYDO_HEIGHT_WITHOUT_FRAME;
    let baseScale = Math.min(widthScale, heightScale);

    if (width <= SMALL_TABLET && width > MOBILE) {
      baseScale = Math.min(baseScale, 0.5);
    } else if (width <= TABLET) {
      baseScale = Math.min(baseScale, 0.65);
    } else if (width <= SMALL_SCREEN) {
      baseScale = Math.min(baseScale, 0.8);
    }

    baseScale = Math.max(0.25, baseScale);

    setScale(baseScale);
  };

  useEffect(() => {
    updateScale();

    window.addEventListener('resize', updateScale);

    return () => window.removeEventListener('resize', updateScale);
  }, []);

  return scale;
};

export default useResponsiveClockScale;
